import { render } from "./PaymentSelectorModal.vue?vue&type=template&id=48b3dcbc"
import script from "./PaymentSelectorModal.vue?vue&type=script&lang=js"
export * from "./PaymentSelectorModal.vue?vue&type=script&lang=js"

import "./PaymentSelectorModal.vue?vue&type=style&index=0&id=48b3dcbc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__